import { queryClient } from '../state/queryClient';
import { store , defineAttachments} from "../state/redux";

import { axios_devis_downloaddevis , axios_devis_registerdevis  } from "../axios/axios_devis";

export const registerdevisfromformules=async(lead,devisformules)=>{
          //DEV AJOUTDEVIS
    // if(devisformules?.length===0){ return }

    let datadevis = {'id_lead': lead.id, 'id_client': lead.id_client} ;

    datadevis['id_1'] =devisformules[0]?.id; datadevis['compagnie_1'] =devisformules[0]?.compagnie ; 
    datadevis['gamme_1'] =devisformules[0]?.gamme; datadevis['nom_formule_1']=devisformules[0]?.nom_formule ; 
    datadevis['prix_1']=devisformules[0]?.prix ; 
    datadevis['id_2'] =devisformules[1]?.id; datadevis['compagnie_2'] =devisformules[1]?.compagnie ; 
    datadevis['gamme_2'] =devisformules[1]?.gamme; datadevis['nom_formule_2']=devisformules[1]?.nom_formule ; 
    datadevis['prix_2']=devisformules[1]?.prix ; 
    datadevis['id_3'] =devisformules[2]?.id; datadevis['compagnie_3'] =devisformules[2]?.compagnie ; 
    datadevis['gamme_3'] =devisformules[2]?.gamme; datadevis['nom_formule_3']=devisformules[2]?.nom_formule ;
    datadevis['prix_3']=devisformules[2]?.prix ; 


    await axios_devis_registerdevis(datadevis) ;
    // DEV DEVIS
    queryClient.invalidateQueries({ queryKey: ['devis',lead.id]}) ;
}

export const downloaddevis =async (devisformules)=>{
    const user= queryClient.getQueryData(['user',localStorage.getItem('token')]);
    const lead = store.getState().lead.leadactu;
    const response = await  axios_devis_downloaddevis({user,lead,sol1:devisformules[0],sol2:devisformules[1],sol3:devisformules[2]}) ; ;

    const pdfData= new Blob([response.data], {type:'application/pdf'}) ; 
    var file = new File([pdfData], `devis${(new Date()).getTime()}.pdf`,{type:'application/pdf'});
    store.dispatch(defineAttachments([file]));      
    return pdfData

}


